import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

import { AdvanceSearchService } from '../../services/Advance-search/advance-search.service';
import { EditDetailsPopupComponent } from '../home-search/edit-details-popup/edit-details-popup.component';
import { EditAdhaarComponent } from '../../atoms/edit-adhaar/edit-adhaar.component';
import { EditNameComponent } from '../../atoms/edit-adhaar/edit-name/edit-name.component';
import { ToastService } from '../../services/toast/toast.service';
import { EditFcComponent } from '../../atoms/edit-fc/edit-fc.component';
import { EditVisitorNameComponent } from '../../atoms/edit-visitor-name/edit-visitor-name.component';

@Component({
  selector: 'app-change-primary-devotee',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatDialogModule],
  templateUrl: './compare-devotee.component.html',
  styleUrl: './compare-devotee.component.scss',
})
export class CompareDevoteeComponent implements OnInit {
  searchForm!: FormGroup;
  fc = new FormControl('');

  profileList: any[] = [];
  profileDetails: any[] = [];

  showEdit = false;
  primaryMemberName: string = '';
  primaryFC: string = '';
  isMobile: boolean = window.innerWidth <= 768;
   // LEFT PANEL
  workerDetails: any[] = [];

  // RIGHT PANEL
  philanthropyMembers: any[] = [];

  constructor(
    private fb: FormBuilder,
    private advanceService: AdvanceSearchService,
    private dialog: MatDialog,
    private toaster: ToastService,
  ) {}

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      familyCode: ['', [Validators.required, Validators.minLength(4)]],
    });
  }

  selectedDevoteeId: string | null = null;

  onSelectDevotee(devoteeId: string): void {
    this.selectedDevoteeId = devoteeId;
  }

  searchByFamilyCode(): void {
    if (this.searchForm.invalid) return;

    const payload = {
      key: this.searchForm.value.familyCode,
      keyType: 'familyCode',
      page: 1,
    };

    this.advanceService.fetchProfile(payload).subscribe({
      next: (res) => {
        this.profileList = res?.data || [];
      },
      error: () => {
        this.profileList = [];
      },
    });
  }

  onRowClick(row: any) {
    this.primaryMemberName =
      `${row.devoteeFirstName} ${row.devoteeMiddleName || ''} ${row.devoteeLastName}`.trim();
    this.primaryFC = row.devoteeFamilyCode;
    this.getProfileDetails(this.primaryFC);
  }

  getProfileDetails(fc: any): void {
    // store primary member name from profile search API

    this.advanceService.fetchVisitorsDetails(fc).subscribe({
      next: (res) => {
        this.profileDetails = res.data || [];
        this.showEdit = true;
      },
      error: (err) => {
        this.toaster.error(err?.error?.message || 'Failed to load details');
      },
    });
  }

  back(): void {
    this.showEdit = false;
  }

  editDetails(item: any): void {
    const dialogRef = this.dialog.open(EditDetailsPopupComponent, {
      width: '800px',
      maxWidth: '90vw',
      data: item,
    });
    // refresh the visitor list once the edit is saved
    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res) this.getProfileDetails(this.primaryFC);
      },
    });
  }

  reset(): void {
    this.searchForm.reset();
    this.profileList = [];
    this.showEdit = false;
  }
  confirmPrimaryChange(item: any, event: MouseEvent): void {
    event.preventDefault();
  }

  allowNum(e: Event) {
    const input = e.target as HTMLInputElement;
    const val = input?.value;
    if (!val) return;

    const filtered = val.replace(/[^0-9]/g, '');
    if (filtered !== val) {
      this.fc.setValue(filtered, { emitEvent: false });
    }
  }

  editAadhaar(item: any): void {
    const dialogRef = this.dialog.open(EditAdhaarComponent, {
      width: '420px',
      data: {
        familyCode: this.primaryFC,
        visitorId: item.visitorId,
        aadhaar: item.aadharNumber,
        editType: 'Visitor',
      },
    });
    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res) {
          this.getProfileDetails(this.primaryFC);
        }
      },
    });
  }
  // editFC(item: any): void {
  //   const dialogRef = this.dialog.open(EditFcComponent, {
  //     width: '420px',
  //     data: {
  //       familyCode: this.primaryFC,
  //       visitorId: item.visitorId,
  //       aadhaar: item.aadharNumber,
  //       editType: 'Visitor',
  //     },
  //   });
  //   dialogRef.afterClosed().subscribe({
  //     next: (res) => {
  //       if (res) {
  //         this.getProfileDetails(this.primaryFC);
  //       }
  //     },
  //   });
  // }

  editFC(item: any): void {
  const dialogRef = this.dialog.open(EditFcComponent, {
    width: '420px',
    data: {
      familyCode: this.primaryFC,
      visitorId: item.visitorId,
      aadhaar: item.aadharNumber,
      editType: 'Visitor',
    },
  });

  // save this visitor's family code / member (and the resulting name) on its
  // own as soon as the dialog returns — no batched "save changes" step
  dialogRef.afterClosed().subscribe({
    next: (res) => {
      if (!res) return;
      const payload = {
        devoteeFamilyCode: this.primaryFC,
        visitorId: Number(item.visitorId),
        visitorName: res.fullName,
        familyCode: res.familyCode,
        memberCode: res.memberCode,
        removeFamilyCode: false,
      };
      this.advanceService.updateVisitor(payload).subscribe({
        next: (apiRes: any) => {
          this.toaster.success(apiRes?.message || 'Visitor details updated');
          this.getProfileDetails(this.primaryFC);
        },
        error: (err: any) => {
          this.toaster.error(err?.error?.message || 'Failed to update visitor details');
        },
      });
    },
  });
}
  getWorkerDetails(familyCode: string): void {
    this.workerDetails = [];
    this.philanthropyMembers = [];

    this.advanceService.fetchProfileDetailsWithProfileY(familyCode).subscribe({
      next: (res) => {
        const data = res?.data;

        this.workerDetails = [
          ...data.devoteeProfileInAccommodation.filter(
            (i: any) => i.isPrimaryDevotee,
          ),
          ...data.devoteeProfileInAccommodation.filter(
            (i: any) => !i.isPrimaryDevotee,
          ),
        ];

        this.philanthropyMembers = data.devoteeDetailsInPhilanthropy || [];

        // this.showDetails = true;
      },
      error: () => {
        this.workerDetails = [];
        this.philanthropyMembers = [];
      },
    });
  }

  editName(item: any): void {
    const dialogRef = this.dialog.open(EditNameComponent, {
      width: '420px',
      data: {
        selected: `${item.devoteeFirstName} ${item.devoteeLastName}`,
        familyCode: item.devoteeFamilyCode,
        memberCode: item.devoteeMemberCode,
        devoteeId: item.devoteeId,
        list: this.philanthropyMembers,
        memberDetails: this.workerDetails,
      },
    });
    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res !== undefined) {
          this.getWorkerDetails(res);
        }
      },
    });
  }
  

  // free-text name update for a visitor with NO family code (mirrors the
  // user-facing add-visitor name field). A visitor linked to a family code is
  // renamed through the member dropdown in editFC instead.
  editVisitorName(item: any): void {
    const dialogRef = this.dialog.open(EditVisitorNameComponent, {
      width: '420px',
      data: { currentName: item.fullName },
    });

    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (!res?.fullName) return;
        const payload = {
          devoteeFamilyCode: this.primaryFC,
          visitorId: Number(item.visitorId),
          visitorName: res.fullName,
        };
        this.advanceService.updateVisitor(payload).subscribe({
          next: (apiRes: any) => {
            this.toaster.success(apiRes?.message || 'Visitor name updated');
            this.getProfileDetails(this.primaryFC);
          },
          error: (err: any) => {
            this.toaster.error(err?.error?.message || 'Failed to update name');
          },
        });
      },
    });
  }

  deleteFamilyCode(item: any) {
  const payload = {
   devoteeFamilyCode: this.primaryFC,
    visitorId: Number(item.visitorId),
    removeFamilyCode: true
  };

  this.advanceService.updateVisitor(payload).subscribe({
    next: (res:any) => {
      this.toaster.success("Visitor's family code successfully removed");
      this.getProfileDetails(this.primaryFC);
    },
    error: (err:any) => {
      this.toaster.error(err?.error?.message || "Failed to remove visitor's family code");
    }
  });
}
}

